import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    Carousel,
    PageSection,
    SectionTitle,
    MarkdownContent,
} from 'wanderu-components';

import styles from './TravelOptionsCarousel.scss';

const propTypes = {
    buttonLabel: PropTypes.string,
    buttonUrl: PropTypes.string,
    carouselData: PropTypes.arrayOf(PropTypes.element).isRequired,
    description: PropTypes.string,
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    carouselClassName: PropTypes.string,
    layoutClassName: PropTypes.string,
    descriptionClassName: PropTypes.string,
    subheaderImage: PropTypes.string,
    showArrows: PropTypes.bool,
};

const defaultProps = {
    buttonLabel: '',
    buttonUrl: '',
    description: '',
    className: '',
    carouselClassName: '',
    layoutClassName: '',
    descriptionClassName: '',
    subheaderImage: '',
    showArrows: true,
    showHints: false,
};

function TravelOptionsCarousel(props) {
    const {
        buttonLabel,
        buttonUrl,
        carouselData,
        description,
        title,
        label,
        className,
        carouselClassName,
        layoutClassName,
        descriptionClassName,
        subheaderImage,
        showArrows,
    } = props;

    return (
        <PageSection
            aria-labelledby={label}
            className={className}
            layoutClassName={`${styles.layout} ${layoutClassName}`}
        >
            <SectionTitle
                className={styles.toCarouselTitle}
                id={label}
            >
                {title}
            </SectionTitle>
            {!!description && (
                <MarkdownContent className={`${styles.description} ${descriptionClassName}`}>
                    {description}
                </MarkdownContent>
            )}
            {!!subheaderImage && (
                <img
                    alt=""
                    className={styles.subheaderImage}
                    src={subheaderImage}
                />
            )}
            <div className={`${carouselClassName} ${styles.carouselContainer}`}>
                <Carousel
                    activeIndicatorStyle={styles.carouselIndicator}
                    autoplay={false}
                    className={styles.carousel}
                    showArrows={showArrows}
                    showHints={true}
                    showSwitcher={false}
                    wrap={false}
                >
                    {carouselData}
                </Carousel>
            </div>
            {!!buttonUrl && (
                <A
                    className={styles.travelOptionsLinkContainer}
                    href={buttonUrl}
                    native
                >
                    {buttonLabel}
                </A>
            )}
        </PageSection>
    );
}

TravelOptionsCarousel.propTypes = propTypes;
TravelOptionsCarousel.defaultProps = defaultProps;

export default TravelOptionsCarousel;
